import React from "react";
import {
    Tree,
    Card,
    Divider,
    Empty,
    Tag,
    Space,
    Typography
} from "antd";

import {
    ApartmentOutlined,
    DeploymentUnitOutlined,
    InboxOutlined
} from "@ant-design/icons";

const { Text } = Typography;

const getIcon = (level) => {

    if (level === "SSCC") {
        return (
            <ApartmentOutlined />
        );
    }

    if (level === "CS") {
        return (
            <DeploymentUnitOutlined />
        );
    }

    return (
        <InboxOutlined />
    );
};

const getTagColor = (level) => {

    if (level === "SSCC") {
        return "blue";
    }

    if (level === "CS") {
        return "purple";
    }

    return "green";
};

const buildTreeData = (
    nodes = []
) => {

    return nodes.map(
        (node) => ({

            key: node.id,

            title: (
                <Space>

                    {
                        getIcon(
                            node.level
                        )
                    }

                    <Text>
                        {
                            node.sscc_code
                        }
                    </Text>

                    <Tag
                        color={
                            getTagColor(
                                node.level
                            )
                        }
                    >
                        {
                            node.level
                        }
                    </Tag>

                </Space>
            ),

            children:
                buildTreeData(
                    node.children || []
                )

        })
    );

};

const SSCCHierarchyTree = ({
    hierarchyTree = [],
    unlinkedSSCCs = []
}) => {

    return (
        <>

            <Card
                title="Connected Hierarchy"
                size="small"
            >

                {
                    hierarchyTree.length ? (

                        <Tree
                            showLine
                            defaultExpandAll
                            treeData={
                                buildTreeData(
                                    hierarchyTree
                                )
                            }
                        />

                    ) : (

                        <Empty
                            description="No hierarchy created"
                        />

                    )
                }

            </Card>

            <Divider />

            <Card
                title="Available For Mapping"
                size="small"
            >

                {
                    unlinkedSSCCs.length ? (

                        <Space
                            direction="vertical"
                            style={{
                                width: "100%"
                            }}
                        >

                            {
                                unlinkedSSCCs.map(
                                    (
                                        item
                                    ) => (

                                        <Card
                                            key={
                                                item.id
                                            }
                                            size="small"
                                        >

                                            <Space>

                                                {
                                                    getIcon(
                                                        item.level
                                                    )
                                                }

                                                <Text>
                                                    {
                                                        item.sscc_code
                                                    }
                                                </Text>

                                                <Tag
                                                    color={
                                                        getTagColor(
                                                            item.level
                                                        )
                                                    }
                                                >
                                                    {
                                                        item.level
                                                    }
                                                </Tag>

                                            </Space>

                                        </Card>

                                    )
                                )
                            }

                        </Space>

                    ) : (

                        <Empty
                            description="All SSCCs mapped"
                        />

                    )
                }

            </Card>

        </>
    );
};

export default SSCCHierarchyTree;